import axios from '@utils/axios';

const orderViewDetail = {
  state: {
    orderId: 0,
    customer: '',
    orderNumber: 0,
    complete: false,
    productTypeId: 0,
    created: '',
    moneyVouchers: [],
    productVoucher: '',
    cashPayment: null,
    cardPayment: null,
    bankTransferPayment: null,
    amount: 0
  },
  mutations: {
    setOrderId(state, val) {
      state.orderId = val;
    },
    setCustomer(state, val) {
      state.customer = val;
    },
    setOrderNumber(state, val) {
      state.orderNumber = val;
    },
    setComplete(state, val) {
      state.complete = val;
    },
    setProductTypeId(state, val) {
      state.productTypeId = val;
    },
    setCreated(state, val) {
      state.created = val;
    },
    setMoneyVouchers(state, val) {
      state.moneyVouchers = val;
    },
    setProductVoucher(state, val) {
      state.productVoucher = val;
    },
    setCashPayment(state, val) {
      state.cashPayment = val;
    },
    setCardPayment(state, val) {
      state.cardPayment = val;
    },
    setBankTransferPayment(state, payment) {
      state.bankTransferPayment = payment;
    },
    setAmount(state, amount) {
      state.amount = amount;
    }
  },
  actions: {
    fetchOrder(context) {
      return axios.get('admin/orders/getorder', {
        params: {
          Id: context.state.orderId
        }
      }).then((res) => {
        context.commit('setCustomer', res.data.result.customer);
        context.commit('setOrderNumber', res.data.result.orderNumber);
        context.commit('setComplete', res.data.result.complete);
        context.commit('setProductTypeId', res.data.result.productTypeId);
        context.commit('setCreated', res.data.result.created);
        context.commit('setMoneyVouchers', res.data.result.moneyVouchers.join(', '));
        context.commit('setProductVoucher', res.data.result.productVoucher);
        context.commit('setCardPayment', res.data.result.cardPayment);
        context.commit('setCashPayment', res.data.result.cashPayment);
        context.commit('setBankTransferPayment', res.data.result.bankTransferPayment);
        context.commit('setAmount', res.data.result.amount);
      });
    },
    fetchOrderByPaymentId(context) {
      return axios.get('admin/orders/getorderbypayment', {
        params: {
          Id: context.state.orderId
        }
      }).then((res) => {
        context.commit('setCustomer', res.data.result.customer);
        context.commit('setOrderNumber', res.data.result.orderNumber);
        context.commit('setComplete', res.data.result.complete);
        context.commit('setProductTypeId', res.data.result.productTypeId);
        context.commit('setCreated', res.data.result.created);
        context.commit('setMoneyVouchers', res.data.result.moneyVouchers.join(', '));
        context.commit('setProductVoucher', res.data.result.productVoucher);
        context.commit('setCardPayment', res.data.result.cardPayment);
        context.commit('setCashPayment', res.data.result.cashPayment);
        context.commit('setBankTransferPayment', res.data.result.bankTransferPayment);
        context.commit('setAmount', res.data.result.amount);
      });
    },
    resetContext(context) {
      context.commit('setCustomer', '');
      context.commit('setOrderNumber', 0);
      context.commit('setComplete', false);
      context.commit('setProductTypeId', 0);
      context.commit('setCreated', '');
      context.commit('setMoneyVouchers', []);
      context.commit('setProductVoucher', '');
      context.commit('setAmount', 0);
    },
  },
  namespaced: true
};

export default orderViewDetail;
